<template>
  <b-form-select v-model="selected" :options="options" :state="valid"></b-form-select>
</template>
<script>

export default {
  name: 'ContractTypeSelect',
  props: ['valid'],
  data() {
    return {
      selected: {},
      options: [
        {
          value: '1',
          text: 'Tovary'
        },
        {
          value: '2',
          text: 'Služby'
        },
        {
          value: '3',
          text: 'Práce'
        }     
      ]
    }
  },
  watch: {
    selected () {
      this.$emit('input', this.selected)
    }
  }
}
</script>